// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"540":"5df2ec5f","917":"7e290717"}[chunkId] + ".chunk.js";
};